// extracted by mini-css-extract-plugin
module.exports = {"alert-history-modal":"AlertHistoryModal_alert-history-modal__2pXLU","alert-history-nowrap":"AlertHistoryModal_alert-history-nowrap__3fPBy"};